import { PostPrepTab } from '../constants/packets.constants';

export interface PageTypeInput {
  pageType: string;
  confidence: number;
  stackingId: string;
  data: object; // Additional data
}

export interface PageType {
  type: string; // Page type category
  stackingId: string; // Stacking Id
  pages: PageTypePage[];
}

export interface PageTypePage {
  pdfId: string; // PDF ID
  pdfPageNum: number; // PDF page number
  packagePageNum: number; // Package page number
  autotagPageOrder: number | null; // Autotag page order. Used to track arrangement of pages durint editing
  confidence?: number; // Confidence level
  data: any; // Additional data
}

export interface Pagination {
  currentPage: number;
  itemsOnPage: number;
  hasNextPage: boolean;
}

export interface MLToolPageTypesResponse {
  statusCode: number;
  status: boolean;
  message: any;
  data: MLToolPageTypes[];
  modelErrors: any;
}

export interface MLToolPageTypes {
  ingestion?: any;
  category: string;
  part?: any;
  confidence: number;
  stackingId: string;
}

/**
 * Stacking file and page types after sorting
 */
export interface StackingOrderResult {
  file: File | null;
  pageTypes: MLToolPageTypes[];
  pageTypesData: any[]; // Data that was passed with pages
  flaggedPages: number[];
  autotagPageOrder: Array<number | null>;
}

export interface StackingListResponse {
  statusCode: number;
  status: boolean;
  message: any;
  data: StackingListData[];
  modelErrors: any;
}

export interface StackingListDifferences {
  errorsFound: boolean;
  duplicatesInStackingList: StackingListData[];
  inStackingListNotAzure: StackingListData[];
  inAzureNotStackingList: string[];
}

export interface AddStackingListResponse {
  statusCode: number;
  status: boolean;
  message: any;
  data: string;
  modelErrors: any;
}

export interface StackingListData {
  stackingId: string;
  name: string;
  docType: string;
}

export type BucketType = 'buyers' | 'sellers' | 'both';

export interface StackingSettings {
  mode: StackingMode;
}

export type AddCompanyStackingItemsDto = Array<{
  name: string;
  docType: string;
}>;

export type UpdateCompanyStackingItemsDto = Array<{
  stackingId: string;
  name: string;
  docType: string;
}>;

export enum StackingMode {
  UPLOAD = 'upload',
  EDIT = 'edit',
  PREFERRED_LIST = 'preferred-list',
}

export type PostPrepSelection =
  | PostPrepSelectionPackage
  | PostPrepSelectionSection
  | PostPrepSelectionDocumentType
  | PostPrepSelectionDocumentGroup;

interface PostPrepSelectionPackage {
  tab: PostPrepTab;
  level: 'package';
  displayName: string;
}

interface PostPrepSelectionSection {
  tab: PostPrepTab;
  level: 'section';
  displayName: string;
  sectionName: string;
}

interface PostPrepSelectionDocumentType {
  tab: PostPrepTab.DOCUMENT_TYPES;
  level: 'document-type';
  displayName: string;
  sectionName: string;
  documentIndex: number;
}

interface PostPrepSelectionDocumentGroup {
  tab: PostPrepTab.DOCUMENT_GROUPS;
  level: 'document-group';
  displayName: string;
  documentIndex: number;
  documentGroup: string;
}
